<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.title" placeholder="发票名称" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}<small>{{item.status_name}}</small></Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.buyer_id"  clearable filterable  placeholder="采购信息">
                                      <Option :value="item.buyer_id" v-for="(item,index) in buyerList" :key="index">{{item.title}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.company_id"  clearable filterable  placeholder="供应商">
                                        <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.expend_id"  clearable filterable  placeholder="支出记录">
                                        <Option :value="item.expend_id" v-for="(item,index) in expendList" :key="index">{{item.sn}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.inv_type" clearable
                                            filterable placeholder="发票类型">
                                        <Option :value="item.id" v-for="(item,index) in invTypeList" :key="index">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.apply_id" clearable
                                            filterable placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">
                                            {{ item.real_name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 添加发票</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #title="{ row }">
                                    <div class="d-width cursor text-primary" :title="row.title" @click="showData(row.inv_id)">
                                        <span>{{row.title}}</span>
                                    </div>
                                </template>
                                <template #inv_type="{ row }">
                                    <Tag>{{row.inv_type_name}}</Tag>
                                </template>
                                <template #inv_money="{ row }">
                                    <span class="text-primary">{{row.inv_money}}</span>
                                </template>
                              <template #use_inv_money="{ row }">
                                <span class="text-orange">{{row.use_inv_money}}</span>
                              </template>
                                <template #inv_company_id="{ row }">
                                    <div class="d-width" :title="row.company">
                                        <span>{{row.company}}</span>
                                    </div>
                                </template>
                                <template #expend_id="{ row }">
                                    <span class="text-999" v-if="row.expend_sn.length <= 0">未绑定</span>
                                    <div v-else>
                                      <Tag class="cursor" v-for="(item,idx) in row.expend_sn" :key="idx" color="orange" @click="showIncomeData(item)" >{{item}}</Tag>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" text="待审核" />
                                    <Badge v-else-if="row.status === 3" color="green" text="已开票" />
                                    <Poptip v-else-if="row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" text="已驳回" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        <span>{{row.remark ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a v-if="row.use_inv_money < row.inv_money" class="text-font-sm text-orange" @click="bindData(row.inv_id)">绑定</a>
                                    <a v-else class="text-font-sm text-primary" @click="clearData(row.inv_id)">清空</a>
                                    <Divider type="vertical" />
                                    <a class="text-font-sm text-primary"  @click="editData(row.inv_id)">编辑</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && !row.expend_id"/>
                                    <a class="text-font-sm text-danger" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && !row.expend_id" @click="deleteData(row.inv_id, index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 创建/编辑  -->
                    <bind-modal v-if="is_bind" ref="BindRef" @trueHandler="saveData"></bind-modal>

                    <!-- 发票详情  -->
                    <show-invoice-modal v-if="is_show" ref="ShowInvoiceRef"></show-invoice-modal>

                    <!-- 收款详情  -->
                    <show-income-modal v-if="is_income_show" ref="ShowIncomeRef"></show-income-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../ExpendCreate";
import ShowInvoiceModal from "../ExpendShow";
import BindModal from "../ExpendBind";
import {deleteExpendInvoice, getExpendInvoiceConfig, getExpendInvoiceList, clearExpendInvoice} from "@/apis/invoice/expend";
import ShowIncomeModal from "@/view/expend/Show";
export default {
    name: "ExpendInvoiceIndex",
    components: {
        Headers, Side, AddModal, ShowInvoiceModal, ShowIncomeModal, BindModal
    },
    data () {
        return {
            expendList: [],
            invTypeList: [],
            userList: [],
            projectList: [],
            companyList: [],
            buyerList: [],

            search: {
                title: '',
                expend_id: '',
                project_id: '',
                company_id: '',
                buyer_id: '',
                inv_type: '',
                apply_id: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '发票名称',
                    key: 'title',
                    slot: 'title',
                    fixed:'left',
                    width : 200
                },
                {
                    title: '开票金额',
                    key: 'inv_money',
                    slot: 'inv_money',
                    width: 160
                },
              {
                title: '已绑金额',
                key: 'use_inv_money',
                slot: 'use_inv_money',
                width: 160
              },
                {
                    title: '发票类型',
                    key: 'inv_type',
                    slot: 'inv_type',
                    width: 120
                },
                {
                    title: '开票公司',
                    key: 'inv_company_id',
                    slot: 'inv_company_id',
                    width: 240
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                    width: 100
                },
                {
                    title: '支出记录',
                    key: 'expend_id',
                    slot: 'expend_id',
                    minWidth: 120
                },
                {
                    title: '申请人',
                    key: 'apply_name',
                    width: 100
                },

                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    minWidth:120
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    fixed : 'right',
                    width : 150
                }
            ],
            is_create : false,
            is_show : false,
            is_income_show : false,
            is_bind : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/6 15:48
         **/
        showIncomeData(id){
            let that = this;
            that.is_income_show = true;
            setTimeout(function(){
                that.$refs.ShowIncomeRef.showSn(id);
            })
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
              title: '',
              expend_id: '',
              project_id: '',
              company_id: '',
              buyer_id: '',
              inv_type: '',
              apply_id: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 14:05
         **/
        getConfig(){
            let that = this;
          getExpendInvoiceConfig().then(e=>{
                that.expendList = e.data.expendList ?? [];
                that.invTypeList = e.data.invTypeList ?? [];
                that.userList = e.data.userList ?? [];
                that.projectList = e.data.projectList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.buyerList = e.data.buyerList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
          getExpendInvoiceList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/7 10:05
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2026/1/7 10:05
         **/
        editData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
      clearData(inv_id){
        let that = this;
        if(!inv_id){
          that.$Message.error({ background: true,duration:3, content:'记录不存在'});
          return;
        }
        that.$Modal.confirm({
          title: '清空绑定记录',
          content: '此操作将清空绑定记录不可恢复, 是否继续?',
          onOk: () => {
            clearExpendInvoice(inv_id).then( e =>{
              that.$Message.success({ background: true,duration:3, content:e.msg});
              that.getList();
            })
          },
          onCancel: () => {}
        });
      },
        /**
         功能：
         time: 2026/1/7 10:05
         **/
        bindData(id){
          let that = this;
          that.is_bind = true;
          setTimeout(function(){
            that.$refs.BindRef.show(id);
          })
        },
        /**
         功能：
         time: 2026/1/7 10:20
         **/
        showData(inv_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowInvoiceRef.show(inv_id);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/7 10:04
         **/
        deleteData(inv_id, index){
            let that = this;
            if(!inv_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteExpendInvoice(inv_id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
